import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const jobFit: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.JOB_FIT,
  label: "Job fit",
  kind: HtsTopicKind.Readiness,
  narrativeFields: [
    "what the candidate understands the day-to-day realities of the role to be, including the hardest parts",
    "how shift work, missed holidays, and exposure to difficult situations would fit their current life and commitments",
  ],
  followUpTriggers: [
    // The HTS doc's own example: "'none of that would affect me' gets one
    // gentle probe before scoring."
    "the answer is a flat \"none of that would affect me\" or similar dismissal",
    "the picture of the role is glamorized (media-drawn, no unglamorous parts named)",
    "the answer doesn't engage with the candidate's own specific life circumstances",
  ],
  hardBarrierFacts: [],
};
